import { type Config, Envs } from '../interfaces';

export const PROD_CONFIG_PART: Partial<Config> = {
  environment: Envs.prod,
  gtmContainerId: 'GTM-MLMGX9C',
  auth: {
    oktaTokenUrl: 'https://login.circlek.com/oauth2/aus779ilxkm8g68ja4x7/v1/token',
    oktaIntrospectUrl: 'https://login.circlek.com/oauth2/aus779ilxkm8g68ja4x7/v1/introspect',
    oktaClientId: '0oaw4fd0u8z6Xh79R4x7',
    redirectUri: 'https://rewards.circlek.com',
    oktaRedirectUri: 'https://rewards.circlek.com/login/callback',
    webAuthSignInUrl: 'https://auth.circlek.com/en?appId=blt3f7da0d21d0cc2eb',
  },
  rewardsContent: {
    baseUrl: 'https://rewards.circlek.com',
  },
  loyaltyApiUrl: 'https://api.circlek.com/us/loyalty',
  monthlyStatementContent: { baseUrl: 'https://rewards.circlek.com' },
};
